module.exports = __webpack_public_path__ + "static/media/rounding-policy.8148de39.svg";